module.exports = __webpack_public_path__ + "static/media/Apple iPhone XR Yellow.5bf3a5ff.png";